import { render, staticRenderFns } from "./MaterialResponseReview.vue?vue&type=template&id=48ff0914"
import script from "./MaterialResponseReview.vue?vue&type=script&lang=js"
export * from "./MaterialResponseReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports